export default __webpack_public_path__ + "static/media/lock-icon.9eb00f18.svg";